module.exports = __webpack_public_path__ + "Banner_ChefsKitchen-09328ec2349bed74029097308377868d.svg";